import { render, staticRenderFns } from "./CollectionsNavigatorBreadcrumb.vue?vue&type=template&id=affc2f56&scoped=true&"
import script from "./CollectionsNavigatorBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./CollectionsNavigatorBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsNavigatorBreadcrumb.vue?vue&type=style&index=0&id=affc2f56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affc2f56",
  null
  
)

export default component.exports